<script setup lang="ts">

import { ref, watch } from 'vue';
import { NumericValidator, makeInComponentValidationWrapper } from './inputValidation';

const props = defineProps<{
  validator: NumericValidator,
}>();

const emit = defineEmits(['blur'])
const value = defineModel<number>({default: 0});
const root = ref<HTMLInputElement|undefined>(undefined);

const validate = makeInComponentValidationWrapper<number>(
  root, value, props.validator);

function onBlur(evt: Event) {
  emit('blur', evt);
}

watch(value, (_newValue, _oldValue) => {
  validate(undefined);
});

</script>

<template>
  <input
    class="fin-input-numeric"
    ref="root"
    type="number"
    v-model="value"
    @blur="onBlur"
  />
</template>

<style scoped>

input {
  width: 110px;
}

</style>
